import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TreeView from "@material-ui/lab/TreeView";
import MuiTreeItem from "@material-ui/lab/TreeItem";
import { withStyles } from "@material-ui/core/styles";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { connect, useDispatch } from "react-redux";
import { getListeClient } from "../actions";
import { getClient } from "../selectors/clients";
import { InputAdornment, IconButton, InputBase } from "@material-ui/core";
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import ClearIcon from '@material-ui/icons/Clear';
import { arrayToTree } from 'performant-array-to-tree';

const useStyles = makeStyles({
    root: {
        overflow: 'auto',
        maxHeight: 180, // TreeView height
    },
    label: {
        fontSize: 14
    },
    buttonContainer: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '8px',
        marginTop: '12px',
        width: '200px', // Set explicit width to match TreeView
    },
    searchAndReset: {
        display: 'flex',
        alignItems: 'center',
        flexGrow: 1,
        border: '1px solid #ccc',
        borderRadius: '4px',
        padding: '2px 8px',
    },
    inputBase: {
        flexGrow: 1,
        fontSize: 14,
    },
    container: {
        minHeight: 200,
        maxHeight: 200,
        display: 'flex',
        flexDirection: 'column',
        width: '200px', // Set explicit width for the whole component
    }
});

let toExpand = [];

const TreeItem = withStyles({
    root: {
        "&.Mui-selected > .MuiTreeItem-content": {
            color: "red"
        }
    },
    label: {
        fontSize: 14
    }
})(MuiTreeItem);

const TreeClient = ({ clients, handleChange, multiSelection = true, defautLabel = "Client", flatClient }) => {
    const classes = useStyles();
    const [selected, setSelected] = useState([]);
    const [data, setData] = useState([]);
    const [searchClient, setsearchClient] = useState('');
    const dispatch = useDispatch();

    const predefinedClientIds = [
        '210', '212', '217', '222', '226', '228', '229', '230', '231',
        '232', '233', '283', '290', '301', '318', '347', '357', '425',
        '479', '482', '496', '500', '521', '524'
    ];

    useEffect(() => {
        dispatch(getListeClient());
    }, [dispatch]);

    useEffect(() => {
        const filteredClient = (items, term, start = false) => {
            if (start) toExpand = [];
            return items.reduce((acc, item) => {
                if (contains(item.data.label, term)) {
                    if (term !== '') toExpand.push(item.data.id);
                    acc.push(item);
                } else if (item.children && item.children.length > 0) {
                    let newItems = filteredClient(item.children, term);
                    if (newItems && newItems.length > 0) {
                        let itemToPush = { data: item.data, children: newItems };
                        if (term !== '') toExpand.push(item.data.id);
                        acc.push(itemToPush);
                    }
                }
                return acc;
            }, []);
        };

        if (clients.length) {
            setData(filteredClient(clients, searchClient, true));
        }
    }, [clients, searchClient]);

    // Fonction utilitaire pour trouver un client par ID
    const findClientById = (id, flatList) => {
        return flatList.find(c => String(c.id) === String(id));
    };

    const findAllParentIds = (id, flatList) => {
        const result = [];
        let currentId = id;
        while (currentId) {
            // Appelle la fonction utilitaire qui n'est pas "dans la boucle"
            const currentClient = findClientById(currentId, flatList);

            if (currentClient && currentClient.Id_parent) {
                result.push(String(currentClient.Id_parent));
                currentId = currentClient.Id_parent;
            } else {
                currentId = null;
            }
        }
        return result;
    };

    const getParentsToExpand = (clientIds, flatList) => {
        const parents = new Set();
        for (const id of clientIds) {
            const parentIds = findAllParentIds(id, flatList);
            parentIds.forEach(pid => parents.add(pid));
        }
        return Array.from(parents);
    };

    const handleToggle = (event, nodeIds) => {
        toExpand = nodeIds;
    };

    const inArraySel = (id, dataArray) => {
        return dataArray.includes(id);
    };

    const getIdSelected = (clientNodes, nodeIds, isChildOfSelected = false) => {
        let currentSelection = [];
        clientNodes.forEach(r => {
            if (isChildOfSelected || inArraySel(r.data.id, nodeIds)) {
                currentSelection.push(r.data.id);
                if (r.children.length && multiSelection) {
                    currentSelection = currentSelection.concat(getIdSelected(r.children, nodeIds, true));
                }
            } else if (r.children.length) {
                currentSelection = currentSelection.concat(getIdSelected(r.children, nodeIds, false));
            }
        });
        return currentSelection;
    };

    const handleSelect = (event, nodeIds) => {
        setSelected(nodeIds);
        if (multiSelection) {
            const selectedIds = getIdSelected(data, nodeIds, false).join(',');
            handleChange(selectedIds);
        } else {
            handleChange(nodeIds);
        }
    };

    const labelClick = e => {
        e.preventDefault();
    };

    const createClientTree = (clientsData) => {
        return Object.values(clientsData).map(c => (
            <TreeItem classes={{ label: classes.label }} onLabelClick={labelClick} key={c.data.id} nodeId={c.data.id} label={c.data.label}>
                {createChildren(c.children)}
            </TreeItem>
        ));
    };

    const createChildren = children => {
        if (children) {
            return Object.values(children).map(c => (
                <TreeItem classes={{ label: classes.label }} onLabelClick={labelClick} key={c.data.id} nodeId={c.data.id} label={c.data.label}>
                    {createChildren(c.children)}
                </TreeItem>
            ));
        } else {
            return null;
        }
    };

    const contains = (text, term) => {
        if (!text) return false;
        return text.toLowerCase().includes(term.toLowerCase());
    };

    const handleSearch = e => {
        if (e.target.value === '') toExpand = [];
        setsearchClient(e.target.value);
    };

    const reset = () => {
        setSelected([]);
        toExpand = [];
        setsearchClient('');
        handleChange(null);
    };

    const handlePreselectClients = () => {
        const parentsToExpand = getParentsToExpand(predefinedClientIds, flatClient);
        const newSelected = predefinedClientIds;
        toExpand = Array.from(new Set([...toExpand, ...parentsToExpand]));
        setsearchClient('');

        const fakeEvent = { target: { value: null }, preventDefault: () => { } };
        handleSelect(fakeEvent, newSelected);
    };

    return (
        <div className={classes.container}>
            <div className={classes.buttonContainer}>
                <IconButton
                    aria-label="Sélectionner clients prédéfinis"
                    onClick={handlePreselectClients}
                    color="primary"
                    title="Sélectionner clients prédéfinis"
                    size="small" // Make icon smaller
                >
                    <PlaylistAddCheckIcon fontSize="small" /> {/* Make icon smaller */}
                </IconButton>
                <div className={classes.searchAndReset}>
                    <InputBase
                        value={searchClient}
                        onChange={handleSearch}
                        placeholder={defautLabel}
                        className={classes.inputBase}
                        endAdornment={
                            <InputAdornment position="end">
                                {(searchClient !== '' || selected.length > 0) && (
                                    <IconButton
                                        aria-label="clear search and selection"
                                        onClick={reset}
                                        edge="end"
                                        size="small"
                                    >
                                        <ClearIcon fontSize="small" />
                                    </IconButton>
                                )}
                            </InputAdornment>
                        }
                    />
                </div>
            </div>
            <div>
                <TreeView
                    className={classes.root}
                    defaultCollapseIcon={<ExpandMoreIcon fontSize="small" />}
                    defaultExpandIcon={<ChevronRightIcon fontSize="small" />}
                    multiSelect={multiSelection}
                    expanded={toExpand}
                    selected={selected}
                    onNodeToggle={handleToggle}
                    onNodeSelect={handleSelect}
                >
                    {clients.length !== 0 && createClientTree(data)}
                </TreeView>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        clients: arrayToTree(getClient(state), { parentId: 'Id_parent' }),
        flatClient: getClient(state)
    };
};

const mapDispatchToProps = {
    getListeClient
};

export default connect(mapStateToProps, mapDispatchToProps)(TreeClient);